<div class="container" *ngFor="let event of events | paginate: { itemsPerPage: 4, currentPage: currentPage }">
  <app-international-event-image-holder [event]="event"></app-international-event-image-holder>
</div>

<div class="text-center">
  <pagination-controls (pageChange)="currentPage = $event; handlePageChange();" autoHide="true">
  </pagination-controls>
  <br>
</div>